import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { LogoMark } from "../components/Logo";
import { Lock, AlertCircle } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLogin() {
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  React.useEffect(() => { document.title = "Pendli — Admin"; }, []);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!password) return;
    setLoading(true);
    setError(null);
    try {
      const { data } = await axios.post(`${API}/admin/login`, { password });
      localStorage.setItem("pendli-admin-token", data.token);
      navigate("/admin/dashboard");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Innlogging feilet. Prøv igjen.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main data-testid="admin-login-page" className="min-h-screen bg-ink text-cream flex items-center justify-center px-6 py-12">
      <div className="absolute inset-0 bay-lines opacity-30 pointer-events-none" />

      <div className="relative w-full max-w-md">
        <div className="flex items-center gap-2.5 mb-10 justify-center">
          <LogoMark size={32} />
          <span className="font-display text-2xl font-extrabold text-cream tracking-tight" style={{ letterSpacing: "-0.04em" }}>
            Pendli · Admin
          </span>
        </div>

        <form
          onSubmit={onSubmit}
          data-testid="admin-login-form"
          className="relative bg-ink/60 border border-amber/30 p-8 md:p-10 l-bracket-tl l-bracket-tr l-bracket-bl l-bracket-br"
        >
          <div className="w-12 h-12 bg-amber-deep border border-amber/40 flex items-center justify-center mb-6">
            <Lock size={20} className="text-amber" />
          </div>

          <h1 className="font-display text-3xl md:text-4xl font-extrabold tracking-tighter mb-2" style={{ letterSpacing: "-0.04em" }}>
            Logg inn
          </h1>
          <p className="text-cream/60 text-sm mb-8">
            Internt dashboard for Pendli-leads. Ikke del passordet.
          </p>

          <label className="block text-xs font-bold tracking-widest uppercase text-amber/80 mb-2">
            Passord
          </label>
          <input
            type="password"
            data-testid="admin-password-input"
            required
            autoFocus
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••••••"
            className="w-full bg-transparent border-b border-cream/20 focus:border-amber py-3 text-base text-cream placeholder:text-cream/30 transition-colors"
          />

          {error && (
            <div className="mt-5 flex items-start gap-2 text-orange text-sm" data-testid="admin-login-error">
              <AlertCircle size={16} className="mt-0.5 shrink-0" />
              <span>{error}</span>
            </div>
          )}

          <button
            type="submit"
            disabled={loading || !password}
            data-testid="admin-login-submit"
            className="mt-8 w-full h-12 bg-amber text-ink font-display font-bold text-base hover:bg-amber-hover transition-colors disabled:opacity-60"
          >
            {loading ? "Logger inn..." : "Logg inn →"}
          </button>
        </form>
      </div>
    </main>
  );
}
